import { z } from "zod";

export const reportRequestSchema = z.object({
  name: z.string().trim().min(1, "Required").max(120),
  email: z.string().trim().email("Invalid email").max(160),
  company: z.string().trim().min(1, "Required").max(160),
  reportSlug: z.string().trim().min(1).max(160),
  reportTitle: z.string().trim().min(1).max(240),
  consent: z.boolean().refine((v) => v, { message: "Required" }),
  /** Honeypot - must remain empty. */
  website: z.string().max(0).optional().or(z.literal("")),
  // contextual hidden fields
  pagePath: z.string().trim().max(500).optional().or(z.literal("")),
  jobTitle: z.string().trim().max(120).optional().or(z.literal("")),
  formName: z.string().trim().max(160).optional().or(z.literal("")),
});

export type ReportRequest = z.infer<typeof reportRequestSchema>;
